import { motion } from "framer-motion";
import { Maximize2 } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { PhotoImg } from "./PhotoImg";
import { useViewer } from "./Viewer";

export const PhotoCard = ({ photo, list, index, className = "", sizes, testid }) => {
  const { L, t } = useLang();
  const { open } = useViewer();
  return (
    <motion.button layout initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }} onClick={() => open(list, index)} data-testid={testid || `photo-card-${photo.slug}`}
      className={`group relative block w-full overflow-hidden text-left ${className}`}>
      <PhotoImg photo={photo} sizes={sizes} className="h-full w-full [&>img:last-child]:transition-transform [&>img:last-child]:duration-[1400ms] group-hover:[&>img:last-child]:scale-[1.06]" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-black/0 opacity-70 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="absolute inset-x-0 bottom-0 flex translate-y-2 items-end justify-between p-4 opacity-90 transition-[transform,opacity] duration-500 group-hover:translate-y-0 group-hover:opacity-100 md:p-5">
        <div>
          <div className="kicker !text-[10px] !tracking-[0.28em] !text-white/70">{t(photo.category)}{photo.location ? ` · ${photo.location}` : ""}</div>
          <div className="font-display mt-1 text-lg font-bold text-white md:text-xl">{L(photo, "title")}</div>
        </div>
        <span className="flex h-9 w-9 items-center justify-center border border-white/40 text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100"><Maximize2 size={14} /></span>
      </div>
    </motion.button>
  );
};

export const MasonryGrid = ({ photos, testid = "photo-grid" }) => (
  <div data-testid={testid} className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
    {photos.map((p, i) => {
      const v = p.variants?.medium;
      const ratio = v ? v.width / v.height : 1.5;
      return (
        <div key={p.id} className="break-inside-avoid" style={{ aspectRatio: ratio }}>
          <PhotoCard photo={p} list={photos} index={i} className="h-full" sizes="(max-width:640px) 100vw, (max-width:1024px) 50vw, 33vw" />
        </div>
      );
    })}
  </div>
);
